<template>
  <div class="jin-list-header">
    <div class="jin-list-header-warp" :style="{ 'background-image': `url(${back})`}">
      <h1 class="wow fadeInDown">{{ info.title }}</h1>
      <p class="wow fadeInUp">{{ info.subTitle }}</p>
    </div>
    <div class="jin-list-search">
      <div class="jin-list-search-warp">
        <el-input v-model="name" :placeholder="info.input" @keyup.enter.native="onSearch" />
        <Icon name="search" @click="onSearch" />
      </div>
    </div>
  </div>
</template>

<script>
import { info } from './option'
import { mapGetters, mapActions, mapMutations } from 'vuex'
export default {
  data() {
    return {
      info,
      name: ''
    }
  },
  computed: {
    ...mapGetters([
      'list',
      'category'
    ]),
    attributes() {
      return this.$route.query.attributes
    },
    currActive() {
      return this.$route.query.title
    },
    back() {
      return require(`@/assets/list/${this.attributes}.png`)
    }
  },
  watch: {
    attributes() {
      this.init()
    },
    currActive() {
      this.name = ''
    }
  },
  created() {
    this.init()
  },
  methods: {
    ...mapActions('position', ['GET_LIST']),
    ...mapMutations('position', ['RESET_LIST', 'SET_KEY_WORDS']),
    init() {
      const i = Number(this.attributes)
      this.info.title = i === 1 ? '社会招聘' : '校园招聘'
    },
    async onSearch() {
      this.SET_KEY_WORDS(this.name)
      if (this.name) {
        this.RESET_LIST()
        this.GET_LIST({
          attributes: this.attributes,
          key_words: this.name,
          category_id: this.category.length && this.category.find(item => item.name === this.currActive) ? this.category.find(item => item.name === this.currActive).id : ''
        })
      } else {
        this.Toast('请输入关键字再进行搜索')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.jin-list {
  &-header-warp {
    width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;

    h1,
    p {
      text-align: center;
    }
  }

  &-search {
    display: flex;
    justify-content: center;

    &-warp {
      position: relative;

      /deep/ .el-input {
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;

        input {
          height: 100%;
          border: none;
        }
      }

      i {
        cursor: pointer;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        background: linear-gradient(180deg, #4777f4 0%, #4777f4 100%);
        border-radius: 50%;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .jin {
    &-list {
      &-header-warp {
        height: 112px;

        h1 {
          font-size: 18px;
          font-weight: 500;
          color: #fff;
          line-height: 25px;
        }

        p {
          font-size: 11px;
          line-height: 15px;
          margin-top: 3px;
        }
      }

      /deep/ &-search {
        margin-top: -20px;

        &-warp {
          width: 308px;
          height: 40px;

          /deep/ .el-input {
            input {
              border-radius: 20px;
            }
          }

          i {
            width: 34px;
            height: 34px;
            font-size: 18px;
            right: 3px;
          }
        }
      }
    }
  }
}

@media only screen and (min-width: 769px) {
  .jin {
    &-list {
      &-header {
        background: #f4f5f9;
      }

      &-header-warp {
        height: 270px;

        h1 {
          font-size: 36px;
          font-weight: 800;
          line-height: 50px;
          margin-bottom: 4px;
        }

        p {
          font-size: 16px;
          line-height: 22px;
        }
      }

      /deep/ &-search {
        margin-top: -30px;

        &-warp {
          width: 700px;
          height: 60px;

          .el-input {
            input {
              border-radius: 30px;
            }
          }

          i {
            width: 50px;
            height: 50px;
            font-size: 24px;
            right: 5px;
          }
        }
      }
    }
  }
}
</style>
